module.exports = __webpack_public_path__ + "static/media/i9a.3066cc6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i9a.svg
// module id = 401
// module chunks = 12